/**
 * @module ParallaxEffect
 */
(function ParallaxEffect() {

    function parallaxEffect($dom) {
        /**
         * // local object availability
         * @type {parallaxEffect}
         * @private
         */
        var _this = this;

        /**
         * @type {elements}
         */
        this.$dom = $dom;

        /**
         * @method parallaxImg
         * @returns {undefined}
         */
        this.parallaxImg = function ($img) {
            var $imgParent = $img.parent();
            var scrollEffectRange = 1; // 1 = 0% to 100% , 0.5 = 0% to 50%;
            var imgY = $imgParent.offset().top;
            var scrollY = $(window).scrollTop();
            var viewportHeight = $(window).height();
            var parentHeight = $imgParent.innerHeight();

            // The next pixel to show on screen
            var winBottom = scrollY + viewportHeight;

            // If block is shown on screen
            if (winBottom > imgY && scrollY < imgY + parentHeight) {
                // Number of pixels shown after block appear
                var imgBottom = ((winBottom - imgY) * scrollEffectRange);
                // Max number of pixels until block disappear
                var imgTop = viewportHeight + parentHeight;
                // Percentage between start showing until disappearing
                var imgPercent = ((imgBottom / imgTop) * 100) + (50 - (scrollEffectRange * 50));
            }

            $img.css({
                top: imgPercent + '%',
                transform: 'translate(-50%, -' + imgPercent + '%)'
            });
        };

        /**
         * @method init
         * @returns {undefined}
         */
        this.init = function () {
            _this.$dom.each(function () {
                // Make sure to select only the first descendant of <picture> tag
                var $pictureTag = $(this).children('figure').children('picture');
                var speed = parseInt($(this).attr("data-image-parallax-effect-speed"), 10);
                // Make sure the speed is larger than 0
                if(speed <= 0) {
                    speed = 100;
                }

                // Set height on <picture> tag outside of scroll event for performance reason
                $pictureTag.css({
                    height: speed + 100 + '%'
                });

                _this.parallaxImg($pictureTag);
                $(document).on({
                    scroll: function () {
                        _this.parallaxImg($pictureTag);
                    }
                });
            });
        };

        /**
         * initialize call
         */
        _this.init();

    }


    // define the global scope
    if (!window.Juzo) {
        window.Juzo = {};
    }

    window.Juzo.parallaxEffect = parallaxEffect;
})();


$(document).ready(function () {
    var $elements = $('[data-hook-image-parallax-effect="image-parallax-effect"]');

    if ($elements.length >= 1) {
        new window.Juzo.parallaxEffect($elements);
    }
});